import mitt from 'mitt';

const componentEventBus = new mitt()

export default componentEventBus